import React, {
  useEffect,
  useState,
  useReducer,
  useContext,
  useRef,
} from "react";

import {
  Box,
  Paper,
  Grid,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

import COM_NavBar_Drawer from "../Component/COM_NavBar_Drawer";
import COM_UserProfile_Menu from "../Component/COM_UserProfile_Menu";

// -------------------------------------------------  firebase - 1/2
import { authentication } from "../firebase-config";
import {
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import { UserContext } from "../UserContext";

const {
  REACT_APP_ECLIPSE_API_PUBLIC,
  REACT_APP_ECLIPSE_API,
  REACT_APP_ECLIPSE_API_Local,
} = process.env;

export default function COM_NavBar({ p_Selected_Button }) {
  // -------------------------------------------------  firebase - 2/2
  const [firebase_userInfo, setFirebase_userInfo] = useState({});

  onAuthStateChanged(authentication, (currentUser) => {
    setFirebase_userInfo(currentUser);
  });

  // --------------------------------------- Global variable
  const selected_Button = useRef(p_Selected_Button);

  // --------------------------------------- use context
  const contextValue = useContext(UserContext);

  return (
    <>
      <div className="flexRow_center NavBar_Container">
        <div className="flexRow_start">
          <COM_NavBar_Drawer />
        </div>

        <div className="flexRow_end  ">
          <COM_UserProfile_Menu />
        </div>
      </div>
    </>
  );
}
